__turbopack_context__.v({
  "file-library-item-in": "BoQoCW_file-library-item-in",
  "folderBack": "BoQoCW_folderBack",
  "folderButton": "BoQoCW_folderButton",
  "folderFlap": "BoQoCW_folderFlap",
  "folderLabel": "BoQoCW_folderLabel",
  "folderPaper": "BoQoCW_folderPaper",
  "folderScene": "BoQoCW_folderScene",
  "item0": "BoQoCW_item0",
  "item1": "BoQoCW_item1",
  "item2": "BoQoCW_item2",
  "item3": "BoQoCW_item3",
  "paperLines": "BoQoCW_paperLines",
  "paperTitle": "BoQoCW_paperTitle",
});
